import React from "react";
import { ModalPadrao } from "../../components/Base";
import { BtnSair } from "../../components/Buttons";
import VendaDetalhe from "./VendaDetalhe";

export default function VendaDetalheModal({ idVenda, isLocal, onCancel, onOk, enableEdit }) {
    return <ModalPadrao visible={!!idVenda} footer={<BtnSair onClick={onCancel} />} onCancel={onCancel} width={1000} >
        <div style={{ minHeight: 400 }}>
            <VendaDetalhe id={idVenda} isLocal={isLocal} onCancel={onCancel} onOk={onOk} enableEdit={enableEdit} />
        </div>
    </ModalPadrao>;
}

